import React from "react";
import styles from "./DetailsTab.module.css";

import RpmCcmToggle from "./details-tab/RpmCcmToggle";
import PatientCard from "./details-tab/PatientCard";
import ChartsPanel from "./details-tab/ChartsPanel";
import RPMMonitoringPanel from "./details-tab/RPMMonitoringPanel";
import NotesAIPanel from "./details-tab/NotesAIPanel";
import RailHeader from "./details-tab/RailHeader";

/**
 * DetailsTab — root layout for the redesigned Details tab on the patient
 * detail page.
 *
 * Layout (per Figma):
 *   ┌──────────────────────────────────────────────────────────────────┐
 *   │  [RPM | CCM]                Last called : ...   [<] [Patient n/m] [>] │  (.topRow)
 *   ├──────────────────────────────────────────────┬───────────────────┤
 *   │  PatientCard (shadow card)                   │  RIGHT (merged    │
 *   │                                              │   shadow card):   │
 *   │  ChartsPanel (shadow card)                   │   - Monitoring    │
 *   │                                              │   - Notes/TOCA AI │
 *   └──────────────────────────────────────────────┴───────────────────┘
 *
 * Sub-cards use box-shadow (no borders) per the May 2026 redesign.
 */
const DetailsTab = (props) => {
  const {
    // RPM/CCM page-scope
    chatBotType,
    setChatBotType,
    rpmEnabled,
    ccmEnabled,

    // PatientCard
    patientContacts,
    summary,
    summaryLoading,

    // ChartsPanel (forwards to existing <Charts />)
    chartsIsOpen,
    chartsOnClose,
    handlePatientType,
    isCcmChatStarted,
    onStartTocaCopilot,
    patientType,

    // RPMMonitoringPanel (forwards to existing <Monitoring />)
    sessionId,
    ccmSessionId,
    resetTimer,
    monitoringIsOpen,
    monitoringOnClose,
    defaultTimer,
    noteToPaste,

    // NotesAIPanel
    hasChatbotAccess,
    onNoteClick,
    notesIsOpen,
    notesOnClose,
    chatProps,
    notesAiTab,
    setNotesAiTab,

    // RailHeader
    lastCalled,
    currentPatientIndex,
    totalPatients,
    canGoBack,
    canGoForward,
    onBackPatient,
    onForwardPatient,
  } = props;

  return (
    <>
      <div className={styles.topRow}>
        <RpmCcmToggle
          value={chatBotType}
          onChange={setChatBotType}
          showRpm={rpmEnabled}
          showCcm={ccmEnabled}
        />
        <RailHeader
          lastCalled={lastCalled}
          currentIndex={currentPatientIndex}
          totalPatients={totalPatients}
          canGoBack={canGoBack}
          canGoForward={canGoForward}
          onBack={onBackPatient}
          onForward={onForwardPatient}
        />
      </div>

      <div className={styles.detailsGrid}>
        <div className={styles.leftColumn}>
          <PatientCard
            patientContacts={patientContacts}
            summary={summary}
            summaryLoading={summaryLoading}
          />
          <ChartsPanel
            isOpen={chartsIsOpen}
            onClose={chartsOnClose}
            handlePatientType={handlePatientType}
            setChatBotType={setChatBotType}
            isCcmChatStarted={isCcmChatStarted}
            onStartTocaCopilot={onStartTocaCopilot}
            patientType={patientType}
            chatBotType={chatBotType}
          />
        </div>

        <div className={styles.rightColumn}>
          <div className={styles.rightCard}>
            <div className={styles.cardSection}>
              <RPMMonitoringPanel
                chatBotType={chatBotType}
                sessionId={sessionId}
                ccmSessionId={ccmSessionId}
                resetTimer={resetTimer}
                isOpen={monitoringIsOpen}
                onClose={monitoringOnClose}
                defaultTimer={defaultTimer}
                noteToPaste={noteToPaste}
              />
            </div>
            <div className={styles.cardSection}>
              <NotesAIPanel
                chatBotType={chatBotType}
                hasChatbotAccess={hasChatbotAccess}
                onNoteClick={onNoteClick}
                notesIsOpen={notesIsOpen}
                notesOnClose={notesOnClose}
                chatProps={chatProps}
                activeTab={notesAiTab}
                setActiveTab={setNotesAiTab}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default DetailsTab;
